
import axios from "axios";
import { baseURL } from "../config/api";

export const post_quote = (data: any, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}quote/ConfirmQuote?userId=${userId}`,
        method: "POST",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

export const getQuotePdfSummary = (primaryKey: string, tenantId: string) => {
    return getFetch(`quote/GetQuotePdfSummary/${primaryKey}`, tenantId);
}

export const sendQuoteEmailAPI = (primaryKey: number, cc: string, tenantId: string) => {
    return getFetch(`QuoteEmail?quoteId=${primaryKey}&ccEmail=${cc}`, tenantId);
}

const getFetch = (url: string, tenantId: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            'X-Tenant-ID': tenantId,
        },
        params: params
    }).then(response => response.data);
}